import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useJsonLd, getSiteUrl } from '@/hooks/useJsonLd';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ValueSection from './components/ValueSection';
import ArticleGrid from './components/ArticleGrid';
import TrustSection from './components/TrustSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  const siteUrl = getSiteUrl();

  // Organization JSON-LD
  useJsonLd({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Hipobuy Spreadsheet',
    url: siteUrl,
    description: 'Guide complet pour optimiser vos données avec le hipobuy spreadsheet. Templates, tutoriels et stratégies d\'automatisation.',
    sameAs: [
      'https://kaspreadsheet.com/',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['French'],
    },
  });

  // WebPage JSON-LD
  useJsonLd({
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Hipobuy Spreadsheet : Le Guide Complet Pour Optimiser Vos Données',
    description: 'Découvrez comment utiliser le hipobuy spreadsheet pour organiser, analyser et automatiser vos données efficacement. Guide 2026 complet.',
    url: siteUrl,
    inLanguage: 'fr',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Hipobuy Spreadsheet',
      url: siteUrl,
    },
    about: {
      '@type': 'Thing',
      name: 'hipobuy spreadsheet',
      description: 'Solution de gestion de données pour l\'organisation, l\'automatisation et l\'analyse.',
    },
  });

  useEffect(() => {
    document.title = 'Hipobuy Spreadsheet : Le Guide Complet Pour Optimiser Vos Données | hipobuyspreadsheets.space';
  }, []);

  return (
    <>
      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <ValueSection />
        <ArticleGrid />
        <TrustSection />
        <TestimonialSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}